import { MultiSelectFilter } from '@retail/components';
import { Brand } from '@retail/auth/types';
import { useCampaignTFunction } from '@retail/campaign/i18n';

interface Props {
  brands: Brand[];
  selectedBrands: Brand['brandId'][];
  selectBrands: (brandIds: Brand['brandId'][]) => void;
}

export function SelectBrandFilter({ brands, selectedBrands, selectBrands }: Props) {
  const t = useCampaignTFunction();

  return (
    <MultiSelectFilter
      label={t('campaign.columns.brands')}
      placeholder={t('campaign.actions.searchForBrand')}
      options={brands}
      value={brands.filter(({ brandId }) => selectedBrands.includes(brandId))}
      onChange={(selected) => selectBrands(selected.map(({ brandId }) => brandId))}
      getOptionKey={({ brandId }) => brandId}
      getOptionLabel={({ name }) => name}
    />
  );
}
